module.exports = __webpack_public_path__ + "static/media/commerce.4d9514e5.png";